import React from 'react';
import { Box, Card, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

const NetworkSkeleton = ({ hideLegend = false }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 'calc(100vh - 400px)',
        position: 'relative',
      }}
    >
      {/* Legend Skeleton */}
      {!hideLegend && (
        <Card
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 10,
            width: '100%',
            maxWidth: 200,
            p: 2,
          }}
          variant="outlined"
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
            }}
          >
            {[1, 2, 3, 4, 5].map((item) => (
              <Box
                key={item}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={100} height={20} />
              </Box>
            ))}
          </Box>
        </Card>
      )}
      {/* Nodes Skeleton Map */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          opacity: 0.7,
        }}
      >
        {/* Left Node */}
        <Skeleton
          variant="rectangular"
          width={200}
          height={86}
          sx={{ borderRadius: 2, zIndex: 1 }}
        />

        {/* Straight Connection */}
        <Box sx={{ width: 48, height: 2, bgcolor: 'divider' }} />

        {/* Center Node */}
        <Skeleton
          variant="rectangular"
          width={200}
          height={86}
          sx={{ borderRadius: 2, zIndex: 1 }}
        />

        {/* Fork Connection */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: 48,
            height: 118,
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              width: 24,
              height: 2,
              bgcolor: 'divider',
              transform: 'translateY(-50%)',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              left: 24,
              top: 0,
              width: 24,
              height: 118,
              borderTop: 2,
              borderBottom: 2,
              borderLeft: 2,
              borderColor: 'divider',
              borderRadius: '8px 0 0 8px',
            }}
          />
        </Box>

        {/* Right Nodes */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            zIndex: 1,
          }}
        >
          <Skeleton
            variant="rectangular"
            width={200}
            height={86}
            sx={{ borderRadius: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width={200}
            height={86}
            sx={{ borderRadius: 2 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

NetworkSkeleton.propTypes = {
  hideLegend: PropTypes.bool,
};

export default NetworkSkeleton;
